import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Dialog } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  title: string
  message: string
  open: boolean
  onClose: () => void
  onConfirm: () => void
  loading?: boolean
}

export const DeleteModal = ({
  title,
  message,
  open,
  onClose,
  onConfirm,
  loading = false,
}: Props) => {
  return (
    <F0Dialog
      isOpen={open}
      onClose={onClose}
      title={title}
      primaryAction={{
        label: loading
          ? i18n.t('complaints.delete_modal.deleting')
          : i18n.t('complaints.delete_modal.delete'),
        onClick: onConfirm,
        disabled: loading,
        loading: loading,
      }}
      secondaryAction={{
        label: i18n.t('complaints.delete_modal.cancel'),
        onClick: onClose,
        disabled: loading,
      }}
    >
      <Box gap="s12">
        <Text.Normal>{message}</Text.Normal>
      </Box>
    </F0Dialog>
  )
}
